const logOut = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path stroke-width="0" d="m12.3 4.605 3.5 3.5-3.5 3.5V8.899L5 8.9V7.1l7.3-.001z"/><rect width="8.5" height="12.5" x="1.75" y="1.75" stroke-width="1.5"/></svg>',
};

export { logOut as default };
